import React from 'react';
import PropTypes from 'prop-types';
import { useFrameHooks } from '@xingternal/hub';
import { MetaRenderer } from '@xingternal/meta-renderer';
import { commonMetaRendererResolvers } from '@xingternal/platform-layout-common-meta-renderer-resolvers';
import { NavItem as VertNavItem, NavItemPlaceholder, } from './nav-list/nav-item';
import { SideBarMe, VertNavUl, Nav } from './side-bar.styles';
const VertNavMe = () => (React.createElement(React.Fragment, null,
    React.createElement(SideBarMe, { patternId: "vertical-navigation-expanded" }),
    React.createElement(SideBarMe, { collapsed: true, patternId: "vertical-navigation-collapsed" })));
const sideBarResolvers = {
    VertNavItem,
    VertNavMe,
    VertNavUl,
};
const resolvers = {
    ...commonMetaRendererResolvers,
    ...sideBarResolvers,
};
const arrayOfN = (n) => new Array(n).fill(0).map((_, i) => i);
const placeholders = (React.createElement(VertNavUl, null, arrayOfN(12).map((i) => (React.createElement(NavItemPlaceholder, { key: i })))));
const SideBar = ({ hasUser }) => {
    const { useMetaConfig } = useFrameHooks();
    const { data } = useMetaConfig();
    return (React.createElement(Nav, null, hasUser ? (React.createElement(MetaRenderer, { config: data.navigation.verticalNavigation, resolvers: resolvers })) : (placeholders)));
};
SideBar.displayName = 'SideBar';
SideBar.propTypes = {
    hasUser: PropTypes.bool.isRequired,
};
export { SideBar };
//# sourceMappingURL=side-bar.js.map